import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterArticle_template} from "./filterArticle_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterUser_template} from "./filterUser_template";

declare var ko: any;

export class usersProfileRates_template extends vnTemplate {

    protected brandFilter : filterDropdown_template;

    protected getTemplateHtml(): string {

        return `
                <!-- RATES -->
                <article data-bind="visible: visible" class="user-dashboard">
                    <div class="d-header">
                        <div class="d-header-title">
                            <i class="far fa-sliders-v"></i>
                            <div class="d-section">Rates</div>
                            <div class="d-legend" style="padding-left: 24px;"><span class="highlight">Green rates</span> have not been modified yet<br><span>Grey rates</span> have been modified and can still be edited</div>
                        </div>
                        <div class="d-header-filters">
                            <div class="d-header-specs">
                                ` + this.brandFilter.getHtmlBuild() + `
                                <div id="cta-rates" data-bind="click: onClickEdit" class="d-header-cta cta-rates">Edit rates<i class="far fa-edit"></i></div>
                            </div>
                        </div>
                    </div>
                                           
                    <!-- ko foreach: userRates -->

                    <div data-bind="css: { loading: $parent.isLoading }, foreach: rates"  class="d-content d-rates">
                        <div class="small-card">
                            <div class="card-header">
                                <div data-bind="text: category" class="card-list-title"></div>
                            </div>
                            <div class="card-info">
                            
                                <!-- ko if: (articleCommission && articleCommission != null) -->
                                <div>
                                    <div class="card-list-info">Writer Article Commission</div>
                                    <div data-bind="text: articleCommission, css:{edited:articleCommission_isDefault == false}" class="d-rate"></div>
                                </div>
                                <!-- /ko -->
                            
                                <!-- ko if: (articlePerformance && articlePerformance != null && hasPerformanceLineAsAuthor) -->
                                <div>
                                    <div class="card-list-info">Writer Article Performance</div>
                                    <div data-bind="text: articlePerformance, css:{edited:articlePerformance_isDefault == false}" class="d-rate"></div>
                                </div>
                                <!-- /ko -->
                            
                                <!-- ko if: (tldrCommission && tldrCommission != null) -->
                                <div>
                                    <div class="card-list-info">Writer TLDR commission</div>
                                    <div data-bind="text: tldrCommission, css:{edited:tldrCommission_isDefault == false}" class="d-rate"></div>
                                </div>
                                <!-- /ko -->
                            
                                <!-- ko if: (editorArticleCommission && editorArticleCommission != null) -->                                
                                <div>
                                    <div class="card-list-info">Editor Article Commission</div>
                                    <div data-bind="text: editorArticleCommission, css:{edited:editorArticleCommission_isDefault == false}" class="d-rate"></div>
                                </div>
                                <!-- /ko -->
                            
                                <!-- ko if: (editorArticlePerformance && editorArticlePerformance != null && hasPerformanceLineAsEditor) -->
                                <div>
                                    <div class="card-list-info">Editor Article Performance</div>
                                    <div data-bind="text: editorArticlePerformance, css:{edited:editorArticlePerformance_isDefault == false}" class="d-rate"></div>
                                </div>
                                <!-- /ko -->
                                
                                
                                <!-- ko if: (articleGroup && articleGroup != null) -->
                                <div>
                                    <div class="card-list-info">Writer Article Group</div>
                                    <div data-bind="text: articleGroup, css:{edited:articleGroup_isDefault == false}" class="d-rate"></div>
                                </div>
                                <!-- /ko -->
                                
                                <!-- ko if: (editorArticleGroup && editorArticleGroup != null) -->
                                <div>
                                    <div class="card-list-info">Editor Article Group</div>
                                    <div data-bind="text: editorArticleGroup, css:{edited:editorArticleGroup_isDefault == false}" class="d-rate"></div>
                                </div>
                                <!-- /ko -->
                            </div>
                        </div>
                        
                    </div>
                    <!-- /ko -->
                </article>               
            `;
    }

    protected initPartial(): void {

        this.brandFilter = new filterDropdown_template("rates_brandFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel("brands");
    }

    protected getTemplateName(): string {

        return "usersProfileRates-template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return [""];
    }

    protected buildViewModel(): any {

        let self = this;

        return {
            visible: ko.observable(false),
            hasData: ko.observable(false),
            isLoading: ko.observable(0),
            userRates: ko.observableArray([]),
            onClickEdit: (data, event) => {
                self.onClickEdit(data.id)
            }
        }
    }

    public getViewModelForRequest() {

        return {
            filters : {
                idBrand: this.getTemplateViewModel().rates_brandFilter.selectedOption
            }
        }
    }

    public setUserRates(userRates) {

        let newList = [];
        for (let item of userRates) {

            let rateData: any = {};
            rateData.brand = item.brand;
            rateData.idBrand = item.idBrand;
            rateData.icon = item.icon;
            rateData.rates = [];

            for (let rate of item.rates) {

                let newObj = {
                    articleCommission : null,
                    articleCommission_isDefault : false,
                    articlePerformance : null,
                    articlePerformance_isDefault : false,
                    tldrCommission : null,
                    tldrCommission_isDefault : false,
                    editorArticleCommission: null,
                    editorArticlePerformance: null,
                    articleGroup: null,
                    editorArticleGroup: null,
                    editorArticleCommission_isDefault : false,
                    editorArticlePerformance_isDefault : false,
                    articleGroup_isDefault : false,
                    editorArticleGroup_isDefault: false,
                    hasPerformanceLineAsAuthor: false,
                    hasPerformanceLineAsEditor: false
                };

                for (let key of Object.keys(rate)) {

                    newObj[key] = rate[key];
                    if (key == "articleCommission" && rate[key] == null) {

                        newObj.articleCommission = rate["default_articleCommission"];
                        newObj.articleCommission_isDefault = true;

                    }
                    if (key == "articlePerformance" && rate[key] == null) {

                        newObj.articlePerformance = rate["default_articlePerformance"];
                        newObj.articlePerformance_isDefault = true;
                        newObj.hasPerformanceLineAsAuthor = rate['has_performance_line_as_author'] == undefined ? false : rate['has_performance_line_as_author']
                        newObj.hasPerformanceLineAsEditor = rate['has_performance_line_as_editor'] == undefined ? false : rate['has_performance_line_as_editor']
                    }
                    if (key == "tldrCommission" && rate[key] == null) {

                        newObj.tldrCommission = rate["default_tldrCommission"];
                        newObj.tldrCommission_isDefault = true;
                    }
                    if (!('articleCommission' in rate) && 'default_articleCommission' in rate) {

                        newObj.articleCommission = rate["default_articleCommission"];
                        newObj.articleCommission_isDefault = true;
                    }
                    if (!('articlePerformance' in rate) && 'default_articlePerformance' in rate) {

                        newObj.articlePerformance = rate["default_articlePerformance"];
                        newObj.articlePerformance_isDefault = true;
                        newObj.hasPerformanceLineAsAuthor = rate['has_performance_line_as_author'] == undefined ? false : rate['has_performance_line_as_author']
                        newObj.hasPerformanceLineAsEditor = rate['has_performance_line_as_editor'] == undefined ? false : rate['has_performance_line_as_editor']
                    }
                    if (!('tldrCommission' in rate) && 'default_tldrCommission' in rate) {

                        newObj.tldrCommission = rate["default_tldrCommission"];
                        newObj.tldrCommission_isDefault = true;
                    }

                    if (!('editorArticleCommission' in rate) && 'default_editorArticleCommission' in rate) {

                        newObj.editorArticleCommission = rate["default_editorArticleCommission"];
                        newObj.editorArticleCommission_isDefault = true;
                    }

                    if (!('editorArticlePerformance' in rate) && 'default_editorArticlePerformance' in rate) {

                        newObj.editorArticleCommission = rate["default_editorArticlePerformance"];
                        newObj.editorArticlePerformance_isDefault = true;
                    }

                    if (!('articleGroup' in rate) && 'default_articleGroup' in rate) {

                        newObj.articleGroup = rate["default_articleGroup"];
                        newObj.articleGroup_isDefault = true;
                    }

                    if (!('editorArticleGroup' in rate) && 'default_editorArticleGroup' in rate) {

                        newObj.editorArticleGroup = rate["default_editorArticleGroup"];
                        newObj.editorArticleGroup_isDefault = true;
                    }
                }
                rateData.rates.push(newObj);
            }
            newList.push(rateData);
        }
        this.getTemplateViewModel().userRates(newList);
    }

    public setVisible(visible) {

        this.getTemplateViewModel().visible(visible);
    }

    public setHasData(hasData) {

        this.getTemplateViewModel().hasData(hasData);
    }

    public setBrands(brands: any) {

        this.brandFilter.setOptions(brands);
    }

    public onClickEdit(id) {
        this.caller.editUserRates(id);
    }

    public isLoading(loading){

        this.getTemplateViewModel().isLoading(loading);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/usersProfileRates_template.ts